export default __webpack_public_path__ + "locales/pt/Settings.json?hash=30509c3027303cc08d72bd273d87be04";